export enum RoleModuleType {
  bank = 0,
  provider = 1,
  inspector = 2,
}
